import { render, staticRenderFns } from "./WorkshopRegistrationList.vue?vue&type=template&id=66546f46&scoped=true"
import script from "./WorkshopRegistrationList.vue?vue&type=script&lang=js"
export * from "./WorkshopRegistrationList.vue?vue&type=script&lang=js"
import style0 from "./WorkshopRegistrationList.vue?vue&type=style&index=0&id=66546f46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66546f46",
  null
  
)

export default component.exports